import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import {
    StyledFilterContent,
    StyledQuickFilterBorder,
} from 'src/pages/orders/components/quickFilters/QuickFilters.styled';

export const TabGridContianer = styled.ul`
    display: grid;
    grid-template-columns: repeat(7,1fr) 1.2fr;
    gap: 0px;
    padding: 0;
    margin: 0;
    margin-bottom: 15px;
    ${media.smalDevice`
        grid-template-columns: repeat(7,1fr) 1.2fr;
    `}
    ${media.mobileDevice`
        margin-left: 0px !important;
        padding: 0;
        grid-template-columns: repeat(3,1.2fr)};
        gap: 0px;
        margin-bottom: 0;
        width: 100%;
    `}
`;

export const StyledTabContentContianer = styled.li`
    display: flex;
    flex-direction: column;
    opacity: 1;
    align-items: center;
    justify-content: center;
    position: relative;
    cursor: ${(props) => (props.cursor ? props.cursor : 'none')};

    height: 50px;
    width: 158px;
    box-sizing: border-box;
    background-color: ${({ isSelected }) =>
        isSelected ? '#FFFFFF' : '#EBEDED'};
    border: 0.5px solid #d7dbdb;

    ${media.mobileDevice`
    height: 50px;
    width: auto;
    box-sizing: border-box;
    background-color: ${({ isSelected }) =>
            isSelected ? '#FFFFFF' : '#EBEDED'}; 
    border: 0.5px solid #d7dbdb;
    `}
`;

export const TabContent = styled(StyledFilterContent)`
    // width: max-content;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    ${media.mediumDevice`
        padding: 0 0.3rem;
       
    `}
    ${media.smalDevice`
        padding: 0 0.2rem;
    `}
    ${media.mobileDevice`
        padding: 0;
        width: 100%;
    `}
`;

export const TabSelectedBorder = styled(StyledQuickFilterBorder)``;

export const TabContentFont = styled.p`
    display: block;
    margin: 0;
    text-align: center;
    width: 110px;
    letter-spacing: 0px;
    padding-top: 3px;
    color: ${({ isSelected }) => (isSelected ? '#1010EB' : '#555555')};
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    line-height: 16px;
    opacity: 1;
    ${media.smalDevice`
        margin: 0 18px;
    `}
    ${media.mobileDevice`
        margin: 0;
        text-align: center;
        font-size: 13px;
        color: ${({ isSelected }) => (isSelected ? '#1010EB' : '#202124')};
    `}
`;
